import Reveal from '@/components/feature/Reveal';
import { gallery } from '@/mocks/gallery';

export default function Gallery() {
  return (
    <section id="projekte" className="relative bg-background-100 py-20 md:py-28 scroll-mt-24">
      <div className="w-full px-4 md:px-8">
        <Reveal className="max-w-2xl">
          <span className="inline-flex items-center gap-2 font-label text-xs font-semibold uppercase tracking-[0.32em] text-primary-600">
            <span className="w-6 h-px bg-accent-500" />
            Aus unserer Arbeit
          </span>
          <h2 className="mt-5 font-heading text-3xl md:text-5xl font-semibold leading-tight text-foreground-950">
            Projekte aus der Region
          </h2>
          <p className="mt-5 font-body text-base md:text-lg leading-relaxed text-foreground-600">
            Hecken in Form gebracht, Rasenflächen gepflegt, Außenanlagen am Tennisplatz wieder
            hergerichtet – ein Blick auf echte Ergebnisse.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {gallery.map((item, index) => (
            <Reveal key={item.id} variant="scale" delay={index * 80} className="h-full">
              <figure className="group relative w-full aspect-[4/3] overflow-hidden rounded-xl bg-background-200">
                <img
                  src={item.src}
                  alt={`${item.title} – ${item.subtitle}`}
                  title={`${item.title} | Arnold Gartenpflege`}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.08]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-primary-950/80 via-primary-950/10 to-transparent transition-opacity duration-500 group-hover:from-primary-950/90" />
                <figcaption className="absolute inset-x-0 bottom-0 p-5 md:p-6 translate-y-1.5 transition-transform duration-500 group-hover:translate-y-0">
                  <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-2.5 py-1 font-label text-[11px] font-bold uppercase tracking-wider text-foreground-950">
                    <i className="ri-focus-3-line" />
                    {item.title}
                  </span>
                  <p className="mt-2.5 font-body text-sm md:text-base text-background-100 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    {item.subtitle}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}